<template>
    <v-container>
        <v-row>
            <v-col>

                <div class="headline">Leverandører</div>
                <br>

                <v-row align="center" class="elevation-1 white px-3 mx-1" style="min-height: 72px">
                    <v-col cols="12" lg="auto">
                        <v-btn :disabled="this.$store.getters.rights > 0" color="success" @click="createSupplier">
                            <v-icon left>mdi-plus-circle-outline</v-icon>
                            Ny leverandør
                        </v-btn>
                    </v-col>
                    <v-col>
                        <v-text-field placeholder="søk" v-model="search" clearable append-icon="mdi-magnify"></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <v-data-table :headers="headers" :items="suppliers" :search="search" :loading="suppliersLoading" hide-default-footer :items-per-page="-1" :mobile-breakpoint="0">
                            <template v-slot:item={item}>
                                <tr @click="editSupplier(item)" style="cursor:pointer; white-space: nowrap">
                                    <td>{{item.name}}</td>
                                    <td>{{item.contact}}</td>
                                    <td>{{item.phone}}</td>
                                    <td>{{item.email}}</td>
                                    <td>{{item.web}}</td>
                                    <td class="justify-center layout px-0 align-center">
                                        <v-btn :disabled="$store.getters.rights > 0" @click.stop="editSupplier(item)" color="info" icon>
                                            <v-icon>mdi-pencil</v-icon>
                                        </v-btn>
                                        <v-btn :disabled="$store.getters.rights > 0" @click.stop="showDeleteDialog(item)" color="info" icon>
                                            <v-icon>mdi-delete</v-icon>
                                        </v-btn>
                                    </td>
                                </tr>
                            </template>
                        </v-data-table>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>

        <v-dialog v-model="deleteDialogVisible" width="500px">
            <v-card>
                <v-card-title class="headline grey lighten-2">
                    Slett leverandør?
                </v-card-title>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click="cancelDelete">Avbryt</v-btn>
                    <v-btn @click="deleteSupplier" color="success">OK</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
// import axios from "axios";
export default {
    data() {
        return {
            toBeDeleted: null,
            deleteDialogVisible: false,
            suppliers: [],
            suppliersLoading: false,
            search: "",
            headers: [
                { text: "Navn", value: "name", align: "left", sortable: true },
                { text: "Kontakt", value: "contact", sortable: false },
                { text: "Tlf", value: "phone", sortable: false },
                { text: "Epost", value: "email", sortable: false },
                { text: "Web", value: "web", sortable: false },
                {
                    text: "Handlinger",
                    value: "actions",
                    sortable: false,
                    width: "1%"
                }
            ]
        };
    },
    methods: {
        editSupplier: function(supplier) {
            if (this.$store.getters.rights == 0) this.$router.push(`/supplier/${supplier.id}`);
        },
        createSupplier: function() {
            this.$router.push(`/supplier/${0}`);
        },
        showDeleteDialog: function(supplier) {
            this.toBeDeleted = supplier;
            this.deleteDialogVisible = true;
        },
        deleteSupplier: function() {
            // console.log(this.toBeDeleted.name);
            this.deleteDialogVisible = false;
            // this.toBeDeleted = null;

            this.axios
                .delete(`/supplier/${this.toBeDeleted.id}`)
                .then(response => {
                    if (response.data.success) {
                        let index = this.suppliers.findIndex(s => s.id == this.toBeDeleted.id);
                        this.suppliers.splice(index, 1);
                    }
                    this.toBeDeleted = null;
                })
                .then(() => {
                    this.toBeDeleted = null;
                })
                .catch(() => {
                    this.toBeDeleted = null;
                });
        },
        cancelDelete: function() {
            this.deleteDialogVisible = false;
            this.toBeDeleted = null;
        }
    },
    mounted() {
        this.suppliersLoading = true;
        this.axios
            .get("/supplier")
            .then(response => {
                let suppliers = response.data.data;
                this.suppliers = suppliers.sort((a, b) => {
                    if (a.name < b.name) return -1;
                    else if (a.name > b.name) return +1;
                    else return 0;
                });
            })
            .catch(() => {
                // console.log(err);
            })
            .finally(() => {
                this.suppliersLoading = false;
            });
    },
    beforeRouteEnter(to, from, next) {
        next(vue => {
            vue.$store.commit("showAppBar", true);
            vue.$store.commit("showNavDrawer", true);
        });
    },
};
</script>

<style scoped>
</style>
